import { getChangeRequests } from "@/Washouts/api/common/queries";
import { useQuery } from "@tanstack/react-query";
import pickBy from "lodash-es/pickBy";

interface IUseChangeRequestsDataArgs {
	locationId?: string;
	commissionCycleId?: string;
	enabled?: boolean;
	filter?: {
		userId?: string;
		origin?: "SUPPORT" | "REVIEW" | "";
		supportAssigned?: boolean;
		payPeriodId?: string;
		position?: string;
	};
}

export const useChangeRequestsData = ({
	locationId,
	commissionCycleId,
	filter: originalFilter = {},
	enabled = true,
}: Readonly<IUseChangeRequestsDataArgs>) => {
	const { userId, position, payPeriodId, origin, supportAssigned: escalated } = originalFilter;
	const filter = pickBy(originalFilter, (value) => value === false || Boolean(value));

	return useQuery({
		queryKey: [
			"changeRequests",
			commissionCycleId ?? "",
			payPeriodId ?? "",
			position ?? "",
			userId ?? "",
			origin ?? "",
			escalated ?? "",
		],
		queryFn: async () => {
			if (!locationId) {
				throw new Error("LocationId and commissionCycleId are required");
			}
			const result = await getChangeRequests({ locationId, commissionCycleId, filter });
			if (!result) {
				throw new Error("Something went wrong while fetching change requests data");
			}
			return result;
		},
		staleTime: Infinity,
		enabled: enabled && !!locationId && (!!commissionCycleId || !!payPeriodId),
	});
};
